import MdRipple from 'components/MdRipple/MdRipple'

export default {
  components: {
    MdRipple
  },
  props: {
    mdRipple: {
      type: Boolean,
      default: true
    }
  }
}
